import { useImpersonation } from "@/contexts/ImpersonationContext";

interface SafeImpersonationResult {
  impersonatedCompanyId: string | null;
  impersonatedCompany: { id: string; name: string; plan: string; branche: string | null; trial_ends_at: string | null } | null;
  setImpersonatedCompany: (companyId: string | null) => void;
  clearImpersonation: () => void;
  isImpersonating: boolean;
  allCompanies: { id: string; name: string; plan: string; branche: string | null; trial_ends_at: string | null }[];
  isLoadingCompanies: boolean;
  isLoading: boolean;
  isContextAvailable: boolean;
}

const defaultResult: SafeImpersonationResult = {
  impersonatedCompanyId: null,
  impersonatedCompany: null,
  setImpersonatedCompany: () => {
    console.warn("[useSafeImpersonation] setImpersonatedCompany called outside ImpersonationProvider");
  },
  clearImpersonation: () => {
    console.warn("[useSafeImpersonation] clearImpersonation called outside ImpersonationProvider");
  },
  isImpersonating: false,
  allCompanies: [],
  isLoadingCompanies: false,
  isLoading: false,
  isContextAvailable: false,
};

/**
 * Safe wrapper for useImpersonation that returns default values if used outside provider.
 * Use this in components that might be rendered outside the ImpersonationProvider.
 */
export function useSafeImpersonation(): SafeImpersonationResult {
  // useImpersonation now returns safe defaults internally instead of throwing
  const context = useImpersonation();
  
  // Check if we got the real context or the default fallback
  // by checking if the setImpersonatedCompany is a real function
  const isContextAvailable = context.setImpersonatedCompany.length > 0 || 
    context.allCompanies !== undefined;
  
  return {
    ...context,
    isContextAvailable,
  };
}
